export const eventStopPropagation = (
  event: React.MouseEvent | React.KeyboardEvent,
) => {
  event.stopPropagation();
};
